<!--
 * @Author: DY
 * @Date: 2025-02-17 16:19:26
 * @LastEditTime: 2026-08-12 16:36:16
 * @Description: 物料转换审批【销售管理】
 * @FilePath: \ShiMoMobile\src\views\sales\materialConversionApproval\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialConversionApproval commonListStyles">
            <HeaderNav header-title="物料转换审批" left-icon-name="2" :extr="{ leftCallBack: onClickLeft }"></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">物料转换编号：{{ item.transition_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_str }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>转换类型：{{ item.type_str }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>转换需求：{{ item.need_type_str }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>转换前短描述：{{ item.before_material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>转换后短描述：{{ item.after_material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>登记人：{{ item.creator }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>登记时间：{{ item.creation_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="primary" v-if="[3].includes(item.status)" @click="openForm(item, 'edit')">
                                            编辑
                                        </van-button>
                                        <van-button plain type="danger" v-else @click="openForm(item, 'view')">
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'material-conversion-approval',
    mixins: [mixin_list],
    components: {
        HeaderNav,
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.name === 'materialConversionApprovalHLJ') {
                vm.tableCode = 'product_card_transition_check_hlj';
            } else {
                vm.tableCode = 'product_card_transition_check';
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'material-conversion-approval');
        }
        next();
    },
    data() {
        return {
            tableCode: '',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.saveCallback || this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {

        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        openForm(item, type) {
            this.$router.isBack = 2;
            if (item.need_type === 0) {
                this.$router.push({
                    name: 'materialConversionApplicationForm',
                    params: {
                        type,
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    name: 'approvalProcess',
                    params: {
                        data: item,
                        isReadOnly: [3].includes(item.status) ? false : true,
                    },
                });
            }
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.materialConversionApproval
    width 100%
    height 100%
    background #F0F0F0
    .content
        width 100%
        height calc(100% - 44rpx)
        >>>.van-search
            background #EAEAEA !important
            height 45rpx !important
        >>>.van-search__content
            background #fff !important
</style>
